import { render, staticRenderFns } from "./LiveEvents.vue?vue&type=template&id=03c945bd"
import script from "./LiveEvents.vue?vue&type=script&lang=js"
export * from "./LiveEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports